/**
 * Product card quick-add
 * ---------------------------------------------------------------------------
 * Delegated from the document, so cards injected later (recommendations,
 * wishlist grid, filtered collection pages) work without re-binding.
 *
 * The add itself goes through the shared helper, which dispatches the cart
 * event Horizon listens for — that is what opens the drawer and refreshes it.
 */

import { addToCart } from '@theme/wb-cart-add';

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-wb-quick-add]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const id = button.dataset.wbQuickAdd;
  if (!id || button.disabled) return;

  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';

  try {
    await addToCart([{ id: Number(id), quantity: 1 }], { source: button });
    button.textContent = 'Added ✓';
  } catch (error) {
    button.textContent = error.message || 'Try again';
  } finally {
    setTimeout(() => {
      button.textContent = original;
      button.disabled = false;
    }, 1800);
  }
});
